import React from 'react';

import { Post } from '@vpr/restful';

import { AlbumShareProps, Payload, Share } from './Share';

export const AlbumShare = (props: AlbumShareProps) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - Post is not a valid JSX Element
  <Post>
    {({ post, loading }) => {
      return (
        <Share
          {...props}
          loading={loading}
          api={{
            execute: (payload: Payload) => {
              const reqObj = {
                token: props.token,
                action: 'send_message',
              };

              const data = { ...payload.data, ...reqObj };

              return post({
                credentials: 'include',
                uri: `/showcase/${props.albumId}/send_message`,
                body: JSON.stringify(data),
                onSuccess: payload.onSuccess,
                onError: payload.onError,
              });
            },
          }}
        >
          {props.children}
        </Share>
      );
    }}
  </Post>
);
